import { createSelector } from 'reselect'

export const getFavouriteExpiredAdsLoading = createSelector(
  state => state && state.user && state.user.profile
    && state.user.profile.favouriteAds
  ? state.user.profile.favouriteAds.Expired.isLoading : false,
 	isLoading => isLoading
)
